import { useMemo } from "react";

export default function useCoursePermissions(effectiveUser, course) {
  return useMemo(() => {
    const roles = Array.isArray(effectiveUser?.roles) ? effectiveUser.roles : [];
    const isInstructor = roles.includes("INSTRUCTOR");
    const isCourseCoordinator = roles.includes("COURSE_COORDINATOR");
    const isAdmin = roles.includes("ADMIN") || roles.includes("GLOBAL_ADMIN");
    return {
      roles,
      isInstructor,
      isCourseCoordinator,
      isAdmin,
      isManager: isCourseCoordinator || isAdmin,
      isCompleted: course?.lifecycleStatus === "COMPLETED",
    };
  }, [effectiveUser, course]);
}
